const BASE_URL = import.meta.env.VITE_REACT_APP_BASE_URL;

export const SIGNUP_URL = `${BASE_URL}/signup`;
export const SIGNIN_URL = `${BASE_URL}/login`;
export const FORGOT_PASSWORD = `${BASE_URL}/forgot-password`;
export const VERIFY_TOKEN_PASSWORD_URL = `${BASE_URL}/verify-token-password`;
export const RESET_PASSWORD_URL = `${BASE_URL}/reset-password`;
export const GET_DOCTOR_URL = `${BASE_URL}/getdoctor`;
export const GET_PATIENT_URL = `${BASE_URL}/getpatient`;
export const LOGOUT_URL = `${BASE_URL}/logout`;
export const CREATE_PRICE_URL = `${BASE_URL}/createPrice`;
export const GET_PRICES_URL = `${BASE_URL}/getPrice`;
export const UPDATE_PRICE_URL = `${BASE_URL}/updatePrice`;

export const CUSTOM_OUTSTANDING_URL = `${BASE_URL}/post-payment-outstanding-custom`;